import { BreakpointSmall, BreakpointMedium, BreakpointLarge, BreakpointXlarge } from '@box/blueprint-web-assets/tokens/tokens';
import { useMedia } from './useMedia.js';
var Breakpoint;

(function (Breakpoint) {
  Breakpoint[Breakpoint["Small"] = 1] = "Small";
  Breakpoint[Breakpoint["Medium"] = 2] = "Medium";
  Breakpoint[Breakpoint["Large"] = 3] = "Large";
  Breakpoint[Breakpoint["XLarge"] = 4] = "XLarge";
  Breakpoint[Breakpoint["XXLarge"] = 5] = "XXLarge";
})(Breakpoint || (Breakpoint = {}));

var breakpointsBounds = {
  small: Number(BreakpointSmall.replace('px', '')),
  medium: Number(BreakpointMedium.replace('px', '')),
  large: Number(BreakpointLarge.replace('px', '')),
  xlarge: Number(BreakpointXlarge.replace('px', ''))
};
/**
 * Returns an enum matching a Blueprint breakpoint for current window size.
 *
 * @example
 * const breakpoint = useBreakpoint();
 * return breakpoint > Breakpoint.Medium && 'Hello!';
 *
 * @returns Breakpoint enum
 */

var useBreakpoint = function useBreakpoint() {
  var isSmall = useMedia("(max-width: ".concat(breakpointsBounds.small, "px)"));
  var isMedium = useMedia("(max-width: ".concat(breakpointsBounds.medium, "px)"));
  var isLarge = useMedia("(max-width: ".concat(breakpointsBounds.large, "px)"));
  var isXLarge = useMedia("(max-width: ".concat(breakpointsBounds.xlarge, "px)"));

  if (isSmall) {
    // max 374px
    return Breakpoint.Small;
  }

  if (isMedium) {
    // min 375px - max 767px
    return Breakpoint.Medium;
  }

  if (isLarge) {
    // min 768px - max 1023px
    return Breakpoint.Large;
  }

  if (isXLarge) {
    // min 1023px - max 1219px
    return Breakpoint.XLarge;
  } // min 1220px


  return Breakpoint.XXLarge;
};

export { Breakpoint, useBreakpoint };